import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Modal from '../Modal';
import Icon, { GLYPHS } from '../icon';

const NoPermissionsInfoModal = ({ onCloseHandler, isOpen }) => (
  <Modal close={onCloseHandler} className="c-stripe-info-modal" showCloseButton display-if={isOpen}>
    <div className="o-flexbox o-flexbox--content-align-center o-flexbox--column u-p+">
      <Icon glyph={GLYPHS.capital} size="large" className="c-stripe-info-modal__header-icon" />
      <div className="c-stripe-info-modal__header">Bank Account permission required</div>

      <p className="c-stripe-info-modal__text">You don’t have permission to view or edit the bank account on file.</p>
      <p className="c-stripe-info-modal__text">
        Please contact your team’s primary account owner to update your bank account information to ensure you can get
        paid.
      </p>

      <button className="c-btn c-btn--medium u-mt+ u-width-100" onClick={onCloseHandler}>
        Ok
      </button>
    </div>
  </Modal>
);

NoPermissionsInfoModal.propTypes = {
  onCloseHandler: PropTypes.func,
  isOpen: PropTypes.bool,
};

NoPermissionsInfoModal.defaultProps = {
  isOpen: false,
  onCloseHandler: noop,
};

export default NoPermissionsInfoModal;
